import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faListUl } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import Link from 'Root/Component/Link'

import styles from './index.module.css'

library.add(faListUl)

interface Props {
  id: string
}

const Presences = ({ id }: Props) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <Link
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item
          )}
          to={`/contents/${id}/presences`}
        >
          <FontAwesomeIcon
            className={styles.icon}
            aria-hidden="true"
            icon={['fas', 'list-ul']}
          />
          Elenco presenze
        </Link>
      )}
    </Menu.Item>
  )
}

export default Presences
